import React, { ElementType } from 'react';

import { Flex, type IconProps } from '@chakra-ui/react';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

interface Props {
  Icon?: ElementType<IconProps>;
  label: string;
  subLabel?: string;
  children?: React.ReactNode;
  AddButton?: ElementType;
}

const SidebarCardTemplate = ({ Icon, label, subLabel, children, AddButton }: Props) => (
  <Flex flexDir="column">
    <Flex flexDir="row" alignItems="center" p="8px 4px" data-testid="sidebar-card-template-header">
      {!!Icon && <Icon boxSize="24px" fill="transparent" />}
      <Flex flexDir="column" ml="8px">
        <TextBodyMedium bold>{label}</TextBodyMedium>
        <TextLabel>{subLabel}</TextLabel>
      </Flex>
      {!!AddButton && (
        <Flex
          ml="auto"
          sx={{
            button: {
              height: '32px',
              width: '40px',
            },
          }}
        >
          <AddButton />
        </Flex>
      )}
    </Flex>
    {children}
  </Flex>
);

export { SidebarCardTemplate };
